const statLabelMap = {
    ElementalATK: "Elemental ATK",
    ElementalDMG: "Elemental DMG",
    CritRate: "CRIT Rate",
    CritDMG: "CRIT Damage",
    HPPercent: "HP",
    ATKPercent: "ATK",
    DEFPercent: "DEF",
    BuffAmp: "Buff AMP",
    DebuffAmp: "Debuff AMP",
    MultDebuffAmp: "Debuff AMP Percent",
    MultBuffAmp: "Buff AMP Percent",
    DEFPenetration: "DEF Penetration",
    DamageReduction: "Damage Reduction",
    Healing: "Healing",
    Shield: "Shield Strength",
    TotalDMG: "Damage",
    SpecificATKPercent: "Attack Damage",
    ATKIncrease: "Attack Increase",
    DEFIncrease: "Defense Increase",
    HPIncrease: "HP Increase",
    ElementalRES: "Elemental Resistance Shred",
    DEFReduce: "Enemy Defense Shred",
    ATKSpd: "Attack Speed",
    MoveSpd: "Movement Speed",
    MoveSpdPercent: "Movement Speed",
    DMGTaken: "Damage Taken",
    Burst: "Elemental Burst Damage",
    BaseModifier: "Base Attack Modifier",
    FlatBoost: "Flat Attack Boost",
    TargetedATKIncrease: "Attack Increase",
    MultSpecificATKPercent: "Damage Multiplier",
    FlatATK: "Affection Attack",
    FlatDEF: "Affection Defense",
    FlatHP: "Affection HP",
    SkillHaste: "Skill Haste",
    HealReduce: "Healing Reduction",
    ShieldReduce: "Shield Strength Reduction",
  };
export default statLabelMap

